
import {appContainer} from './appContainer/appContainer';
import {home} from './home/home';
import {booking} from './booking/booking';
import {aboutus} from './aboutus/aboutus';
import {areas} from './areas/areas';
import {skipsizes} from './skipsizes/skipsizes';
import {wastetypes} from './wastetypes/wastetypes';
import {faqs} from './faqs/faqs';
import {contactus} from './contactus/contactus';
import {smallbooking} from './smallbooking/smallbooking';
import {estimator} from './estimator/estimator';
import {placement} from './placement/placement';
import {permit} from './permit/permit';
import {mobileskip} from './mobileskip/mobileskip';
import {areasydney} from './areasydney/areasydney';
import {areanewcastle} from './areanewcastle/areanewcastle';
import {areabrisbane} from './areabrisbane/areabrisbane';
import {areamelbourne} from './areamelbourne/areamelbourne';
import {bookskip} from './bookskip/bookskip';
import {areadipswich} from './areadipswich/areadipswich';

// import {commerce} from './commerce/commerce';

export const components = angular.module('components', [
  appContainer.name,
  home.name,
  booking.name,
  aboutus.name,
  areas.name,
  skipsizes.name,
  wastetypes.name,
  faqs.name,
  contactus.name,
  smallbooking.name,
  estimator.name,
  placement.name,
  permit.name,
  mobileskip.name,
  areasydney.name,
  areanewcastle.name,
  areabrisbane.name,
  areamelbourne.name,
  bookskip.name,
  areadipswich.name
]);



/** WEBPACK FOOTER **
 ** ./src/app/components/components.js
 **/